import http from "../../infrastructure/httpClient";

export enum ResetPasswordStatus {
	Success = 1,
	EmailNotConfirmed,
	ResetFailed,
}

interface IResetPasswordResultDto {
	status: ResetPasswordStatus;
	error: string;
}

const ResetPasswordService = {
	sendPasswordResetEmail: (email: string): Promise<IResetPasswordResultDto> =>
		http.post("reset-password/send", email),

	performPasswordReset: (userId: string, password: string, token: string)
		: Promise<IResetPasswordResultDto> =>
		http.post("reset-password/perform", { userId, password, token })
};

export default ResetPasswordService;